import React, { useState } from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  Alert,
  Dimensions,
  Image,
} from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { Video } from 'expo-av';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { Ionicons } from '@expo/vector-icons';
import { useFonts } from 'expo-font';
import { HeroOutline, HeroSolid } from '@nandorojo/heroicons';

const { width, height } = Dimensions.get('window');

export default function SplashScreen({ navigation }) {
  const [isLoading, setIsLoading] = useState(false);

  // Check for pending token login when component mounts (SSO from zoolife/hexpod)
  React.useEffect(() => {
    const checkPendingTokenLogin = async () => {
      try {
        const pendingToken = await AsyncStorage.getItem('pending_login_token');
        const backUrl = await AsyncStorage.getItem('pending_back_url');
        const action = await AsyncStorage.getItem('pending_action');
        const rewardToken = await AsyncStorage.getItem('pending_reward_token');
        const hexpodUrl = await AsyncStorage.getItem('pending_hexpod_url');

        if (pendingToken) {
          console.log('Pending SSO token found, navigating to TokenLogin');
          // Clear only token/backUrl; TokenLogin reads action/reward/hexpod from AsyncStorage
          await AsyncStorage.multiRemove(['pending_login_token', 'pending_back_url']);

          navigation.navigate('TokenLogin', {
            token: pendingToken,
            backUrl: backUrl,
            action,
            reward_token: rewardToken,
            hexpod_url: hexpodUrl,
          });
        }
      } catch (error) {
        console.error('Error checking pending token login:', error);
      }
    };

    checkPendingTokenLogin();
  }, [navigation]);

  const handleBrowse = () => {
    navigation.navigate('Browse');
  };

  const handleLogin = () => {
    navigation.navigate('Login');
  };

  const handleRegister = () => {
    navigation.navigate('Register');
  };

  const [fontsLoaded] = useFonts({
    'Poppins': require('../../assets/fonts/Poppins-Regular.ttf'),
    'Poppins-Medium': require('../../assets/fonts/Poppins-Medium.ttf'),
    'Poppins-SemiBold': require('../../assets/fonts/Poppins-SemiBold.ttf'),
    'Poppins-Bold': require('../../assets/fonts/Poppins-Bold.ttf'),
  });

  if (!fontsLoaded) {
    return (
      <View style={styles.loadingContainer}>
        <Text style={styles.loadingContainerText}>Loading...</Text>
      </View>
    );
  }

  return (
    <View style={styles.container}>
      {/* Video Background */}
      <Video
        // source={{ uri: 'https://video.wixstatic.com/video/d47472_58cce06729c54ccb935886c4b3647274/1080p/mp4/file.mp4' }}
        source={require('../../assets/smoke3.mp4')}
        style={styles.videoBackground}
        shouldPlay
        isLooping
        isMuted
        resizeMode="cover"
      />
      
      {/* Cyan Color Overlay */}
      <View style={styles.cyanOverlay} />
      
      
        <View style={styles.appContainer}>
        {/* Logo Section */}
        <View style={styles.logoContainer}>
          <View style={styles.logoWrapper}>
            <Image
              source={require('../../assets/ZLC-3d logo-2.png')}
              style={styles.logoImage}
              resizeMode="contain"
            />
          </View>
        </View>

        {/* Buttons Section */}
        <View style={styles.buttonsContainer}>
          {/* Dapatkan Voucher Gratis! - Primary CTA */}
          <TouchableOpacity 
            style={styles.voucherButton}
            onPress={handleLogin}
            activeOpacity={0.8}
          >
            <LinearGradient
              colors={['#FDE047', '#FCD34D', '#FBBF24', '#F59E0B']}
              start={{ x: 0.5, y: 0 }}
              end={{ x: 0.5, y: 1 }}
              style={styles.voucherButtonGradient}
            >
              <HeroSolid.CreditCard height="22" width="22" color="#92400E" style={styles.voucherButtonIconLeft} />
              <Text style={styles.voucherButtonText}>Dapatkan Poin/Voucher Gratis!</Text>
              <HeroOutline.ArrowRight height="20" width="20" color="#FFFFFF" />
            </LinearGradient>
          </TouchableOpacity>

          {/* Browse First Button */}
          <TouchableOpacity 
            style={styles.primaryButton}
            onPress={handleBrowse}
          >
            <Text style={styles.primaryButtonText}>Lihat-lihat dulu</Text>
            <HeroOutline.ArrowRight height="20" width="20" color="#1E293B" />
          </TouchableOpacity>

          {/* Register and Login Buttons */}
          <View style={styles.secondaryButtonsRow}>
            <TouchableOpacity 
              style={styles.secondaryButton}
              onPress={handleLogin}
            >
              <Text style={styles.secondaryButtonText}>Sudah Punya Akun Zoolyfe</Text>
            </TouchableOpacity>
            
            {/* <TouchableOpacity 
              style={styles.secondaryButton}
              onPress={handleLogin}
            >
              <Text style={styles.secondaryButtonText}>Masuk</Text>
            </TouchableOpacity> */}
          </View>
          
          {/* Register Section */}
          <View style={styles.registerSection}>
            <Text style={styles.registerPrompt}>Belum punya akun?</Text>
            <TouchableOpacity 
              style={styles.ghostButton}
              onPress={handleRegister}
            >
              <Text style={styles.ghostButtonText}>Daftar Sekarang</Text>
            </TouchableOpacity>
          </View>
        </View>
        </View>
    </View>
  );
}

const styles = StyleSheet.create({
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  loadingContainerText: {
    fontFamily: 'Poppins',
  },
  container: {
    flex: 1,
  },
  videoBackground: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    width: width,
    height: height,
  },
  cyanOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    backgroundColor: '#22D3EE',
    opacity: 0.2,
  },
  appContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 20,
    paddingTop: 100,
    paddingBottom: 50,
  },
  Gradient: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    width: '100%',
    height: '100%',
  },
  logoContainer: {
    width: '100%',
    maxWidth: 360,
    alignSelf: 'center',
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
  },
  logoWrapper: {
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  logoImage: {
    width: '100%',
    maxWidth: 360,
    aspectRatio: 3400 / 2400,
    alignSelf: 'center',
  },
  clubTextContainer: {
    alignItems: 'end',
    marginTop: 0,
  },
  clubImage: {
    width: 120,
    height: 80,
    alignSelf: 'end',
    marginTop: -30,
  },
  buttonsContainer: {
    width: '100%',
    paddingBottom: 20,
  },
  voucherButton: {
    borderRadius: 6,
    marginBottom: 16,
    overflow: 'hidden',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.25,
    shadowRadius: 8,
    elevation: 6,
  },
  voucherButtonGradient: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 16,
    paddingHorizontal: 24,
  },
  voucherButtonIconLeft: {
    marginRight: 10,
  },
  voucherButtonText: {
    color: '#1E293B',
    fontSize: 14,
    fontWeight: 600,
    marginRight: 10,
    fontFamily: 'Poppins-Semibold',
  },
  primaryButton: {
    backgroundColor: '#F8FAFC',
    borderRadius: 6,
    paddingVertical: 16,
    paddingHorizontal: 24,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 16,
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    elevation: 3,
  },
  primaryButtonText: {
    color: '#1E293B',
    fontSize: 14,
    fontWeight: 500,
    marginRight: 8,
    fontFamily: 'Poppins-Medium',
  },
  secondaryButtonsRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 12,
  },
  secondaryButton: {
    flex: 1,
    backgroundColor: 'transparent',
    borderWidth: 1,
    borderColor: '#F8FAFC',
    borderRadius: 6,
    paddingVertical: 16,
    paddingHorizontal: 24,
    alignItems: 'center',
    justifyContent: 'center',
  },
  secondaryButtonText: {
    color: '#F8FAFC',
    fontSize: 14,
    fontWeight: 500,
    fontFamily: 'Poppins-Medium',
  },
  registerSection: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 16,
  },
  registerPrompt: {
    color: '#E2E8F0',
    fontSize: 12,
    fontWeight: '400',
    fontFamily: 'Poppins',
    marginRight: 8,
  },
  ghostButton: {
    backgroundColor: 'transparent',
    paddingVertical: 4,
    paddingHorizontal: 8,
    borderRadius: 6,
  },
  ghostButtonText: {
    color: '#F8FAFC',
    fontSize: 12,
    fontWeight: 600,
    fontFamily: 'Poppins-Semibold',
  },
});